import { CustomerDetails, permissionAllowed } from "@ews/react-data";
import { useNamedRoutes } from "../../../NamedRoutes";

import
{
    useCustomerDetails,
    useModifyCustomerDetails
} from "../../../ReactData/customer";

import { Locales, localeTranslationKeys } from "../../../../setup/locale";
import { useMyPermissions } from "../../../Login/LoginProvider";
import { useUserName } from "../../../ReactData/user";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import SettingsSelect from "../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect";
import SettingsSelectOption from "../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption";
import { LanguageFormatSettingsProps } from "./types";

const LanguageFormatSettings: React.FC<LanguageFormatSettingsProps> = ({ customer, }) =>
{
    const { params } = useNamedRoutes();
    const { id } = params();
    const format = useCustomerDetails(customer.id || id!);

    const modifiedBy = useUserName(customer.modifiedById || "", true);
    const createdBy = useUserName(customer.createdById || "", true);

    const modifyCustomerDetails = useModifyCustomerDetails();

    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.createCustomer || 0);

    function saveCustomerDetails(key: keyof CustomerDetails, value: any)
    {
        if (!customer.id || !(key in format)) return;
        modifyCustomerDetails(customer.id, { [key]: value } as CustomerDetails);
    }
    return <>
        <SettingsCol>
            <SettingsSelect
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_LANGUAGE_LABEL"}
                value={format.locale || ""}
                onBlur={({ value }) =>
                {
                    if (format.locale === value) return;
                    saveCustomerDetails("locale", value);
                }}>
                {Locales.available
                    .map(locale => <SettingsSelectOption text={localeTranslationKeys[locale]} value={locale} />)}
            </SettingsSelect>
            <SettingsLabel
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_CREATED_BY_USER_LABEL"}
                value={createdBy} />
            <SettingsLabel
                text={"COM_FACPMANAGEMENT_AUTOMATEDMAIL_CREATED"}
                value={
                    customer.created ? new Date(customer.created).toLocaleString() : ""} />
            <SettingsLabel
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_MODIFIED_BY_USER_LABEL"}
                value={modifiedBy} />
            <SettingsLabel
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_MODIFIED_LABEL"}
                value={customer.modified ? new Date(customer.modified).toLocaleString() : ""} />
        </SettingsCol>
        <SettingsCol>

        </SettingsCol>
        <SettingsCol>

        </SettingsCol>

    </>;
};

export default LanguageFormatSettings;